import { z } from 'zod';

// The form is a master boolean plus a key->boolean record whose KEY SET IS DYNAMIC:
// it comes from the money_handling catalogue at runtime (Decision D3), never from a
// hardcoded list, because the capability set is PROVISIONAL pending Finance (PRD 12 Q6-Q9).
//
// A plain z.record with NO refinement is deliberate (Decision D11): every capability
// catalogue row is data_type 'boolean' / is_required false / validation_rules null, so
// there is nothing per-key to assert, and the panel only ever renders and submits keys it
// took from the same live list. The backend ConfigSettingValidator re-enforces ['boolean']
// per key regardless — the client schema is convenience, not the boundary.
export const cthfRulesSchema = z.object({
    cthf_enabled: z.boolean(),
    capabilities: z.record(z.string(), z.boolean()),
});

export type CthfRulesFormValues = z.infer<typeof cthfRulesSchema>;
